import React, { useEffect } from "react";
import { play } from "../Game/Audio/Audio";

import InfoPane from "../UI/InfoPane";

import "./NotFound.scss";

import boom from "./boom.jpg";

const Body = () => <p>Be sure you didn't fiddle with the URL -- that's the surest way to see this page.</p>;

function NotFound() {
  useEffect(() => {
    play("EXPLOSION");
  }, []);

  return <InfoPane title="Not found" subtitle="404" imgSrc={boom} imgAlt="404" bodyRender={Body} />;
}

export default NotFound;
